import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpBaseService } from 'src/app/services/http-base.service';
import { environment } from 'src/environments/environment';
import { ConsultaList } from '../model/core/ConsultaList.model';
import { Notificacion } from '../model/general/notificacion.model';

const API_URL = environment.apiUrl;
const SUBMODULO = 'notificaciones';

@Injectable({
  providedIn: 'root'
})
export class NotificacionService extends HttpBaseService<Notificacion> {

  private headersJson = new HttpHeaders({
    'Content-Type': 'application/json',
    'X-Auth-Token': localStorage.getItem('tkCocred'),
  });

  constructor(private http: HttpClient) {
    super(http, SUBMODULO);
  }

  //Obtener las notificaciones por idUsuario (no leidas)
  obtenerNotPorUsuario(idUser: number) {
    return this.http.get<ConsultaList<Notificacion>>(API_URL + SUBMODULO + "/notPorUser/" + idUser, { headers: this.headersJson });
  }
  //Consulta notificaciones por parametros (paginacion)
  consultaNotByParams(consulta: ConsultaList<Notificacion>) {
    return this.http.post<any>(API_URL + SUBMODULO + '/notParametros', consulta, { headers: this.headersJson });
  }

}